import Modal from "../../../../components/common/form/Modal";
import { FC, useState } from "react";
import { ModalProps } from "../../../../helpers/constants";
import { useSearchUsersQuery } from "../../users/usersApi";
import { DataTable } from "../../../../components/common/datatable/DataTable";
import { useAddNewMemberIntoTeamMutation, useGetTeamByIdQuery } from "../teamsApi";
import { skipToken } from "@reduxjs/toolkit/query";
import { handleRTKQuery } from "../../../../helpers/utils/RtkQueryUtils";
import { DataTableColumn } from "../../../../components/common/datatable/DataTableTypes";
import ButtonTray from "../../../../components/common/form/ButtonTray";
import { FaMagnifyingGlass } from "react-icons/fa6";

interface props extends ModalProps {
    teamId: string | undefined
}

const AddMember: FC<props> = ({ teamId, show, setShow }) => {

    const teamByIdQuery = useGetTeamByIdQuery(teamId ?? skipToken);
    const [userId, setUserId] = useState<any>(null);
    const [addMemberApi, addMemberApiResponse] = useAddNewMemberIntoTeamMutation();
    const [selectedRow, setSelectedRow] = useState<any>({});

    let customFilter: Record<string, any> = {
        tenant: teamByIdQuery?.data.tenant,
        teamId: teamId,
        teamParam: "Is_MEMBER_SEARCH_PARAM"
    };

    if (teamByIdQuery?.data?.customerId !== null && teamByIdQuery?.data?.customerId !== undefined) {
        customFilter.customerId = teamByIdQuery.data.customerId;
    }

    const columns: DataTableColumn[] = [
        {
            label: "Name",
            accessor: "username",
            filterOptions: [{
                filterModalOption: {
                    filterModalPlaceHolder: "Enter Name...",
                    filterModalKey: "username",
                    filterModalIcon: <FaMagnifyingGlass size={14} className={''} />
                },
                overrideFilterLabel: " ",
                overrideFilterAccessor: "username"
            }],
        },
        {
            label: "Email",
            accessor: "email"
        },
        {
            label: "Customer",
            accessor: "customer.customerName",
            canSort: false
        },
    ];

    const handleAddMember = async () => {
        await handleRTKQuery(() => {
            addMemberApi({ teamId, userId: selectedRow.id });
        }, () => {
            setShow(false);
        });
    }

    return (
        <>
            <Modal title={"Member Selector"} show={show} setShow={setShow} className={"w-3/5 bg-text-0 rounded-lg shadow-lg"}
                fields={
                    <>
                        <DataTable
                            columns={columns}
                            actions={{
                                fetchAction: useSearchUsersQuery
                            }}
                            defaultFilter={{
                                ...customFilter
                            }}
                            renderOptions={{ skipUserSettingRender: true, skipButtonSectionRender: true, skipFilterButtonRender: true }}

                            rowSelectionOptions={{
                                enableRowSelection: true,
                                onSelectionChange: (selectedRows) => {
                                    const [row] = Array.from(selectedRows);
                                    if (row) {
                                        setSelectedRow(row)
                                    }
                                },
                            }}
                            appendFilterToUrl={false}
                        />
                        <div className={'mt-4 border-t border-t-surface-5 flex justify-end'}>
                            <ButtonTray
                                buttons={[
                                    {
                                        buttonProps: {
                                            btnText: "Cancel",
                                            onClick: () => setShow(false),
                                            type: "close",
                                        },
                                        buttonType: "button"
                                    },
                                    {
                                        buttonProps: {
                                            btnText: "Submit",
                                            onClick: handleAddMember,
                                            type: "button",
                                            isLoading: (addMemberApiResponse.isLoading),
                                        },
                                        buttonType: "button",
                                    }
                                ]}
                                align={"end"}
                                gap={2}
                            />
                        </div>

                    </>
                }
            />

        </>
    )
}
export default AddMember;